import type { ColorChoice, ImageType } from '@coursera-web/cds-labs';

import type { UpsellType } from '@coursera/event-pulse-types';

import c4bEyebrow from 'images/browse-common/c4b-eyebrow.png';
import c4bLearner from 'images/browse-common/c4b-learner-image.png';
import cplusEyebrow from 'images/browse-common/cplus-eyebrow.png';
import BgImage from 'images/browse-common/cplus-learner-image.png';
import duke from 'images/browse-common/duke.png';
import google from 'images/browse-common/google.png';
import ibm from 'images/browse-common/ibm.png';
import illinois from 'images/browse-common/illinois.png';
import imperial from 'images/browse-common/imperial.png';
import penn from 'images/browse-common/penn.png';
import stanford from 'images/browse-common/stanford.png';
import umich from 'images/browse-common/umich.png';

import _t from 'i18n!nls/browse-common';

export type PartnerData = {
  relationSlug: string;
  imageAltText: string;
  image: { url: string };
  partnerName: string;
};

export type UpsellCardData = {
  id: UpsellType;
  headline: string;
  body?: string;
  target: string;
  ctaText: string;
  backgroundColor?: ColorChoice;
  eyebrowImage?: ImageType;
  cardBackgroundImage: {
    url: string;
    title: string;
    contentType: string;
    description: string;
    width: number;
    height: number;
  };
};

export const getUpsellCards = (): UpsellCardData[] => [
  {
    id: 'coursera_plus',
    headline: _t('Reach your career goals with Coursera Plus'),
    body: _t(
      'Subscribe and get unlimited access to 7000+ courses, projects, Specializations, and Professional Certificates'
    ),
    target: '/courseraplus',
    ctaText: _t('Learn more'),
    backgroundColor: 'blue',
    eyebrowImage: {
      url: cplusEyebrow,
      description: 'Coursera Plus eyebrow',
      width: 158,
      height: 16,
    },
    cardBackgroundImage: {
      url: BgImage,
      title: 'Coursera Plus Upsell Card',
      contentType: 'image/png',
      description: 'Coursera Plus Upsell Card',
      width: 260,
      height: 310,
    },
  },
  {
    id: 'enterprise',
    headline: _t('Join over 4,300 companies using Coursera to develop talent'),
    target: '/business',
    ctaText: _t('Learn more'),
    backgroundColor: 'dark-blue',
    eyebrowImage: {
      url: c4bEyebrow,
      description: 'Coursera Business Upsell Card',
      width: 215,
      height: 19,
    },
    cardBackgroundImage: {
      url: c4bLearner,
      title: 'Coursera Business Upsell Card',
      contentType: 'image/png',
      description: 'Coursera Business Upsell Card',
      width: 260,
      height: 310,
    },
  },
];

export const getPartnerData = () => [
  {
    relationSlug: 'illinois',
    imageAltText: _t('University of Illinois at Urbana-Champaign'),
    partnerName: 'University of Illinois at Urbana-Champaign',
    image: { url: illinois },
  },
  {
    relationSlug: 'duke',
    imageAltText: _t('Duke University'),
    partnerName: 'Duke University',
    image: { url: duke },
  },
  {
    relationSlug: 'google',
    imageAltText: _t('Google'),
    partnerName: 'Google',
    image: { url: google },
  },
  {
    relationSlug: 'umich',
    imageAltText: _t('University of Michigan'),
    partnerName: 'University of Michigan',
    image: { url: umich },
  },
  {
    relationSlug: 'ibm-skills-network',
    imageAltText: _t('IBM'),
    partnerName: 'IBM',
    image: { url: ibm },
  },
  {
    relationSlug: 'imperial',
    imageAltText: _t('Imperial College of London'),
    partnerName: 'Imperial College of London',
    image: { url: imperial },
  },
  {
    relationSlug: 'stanford',
    imageAltText: _t('Stanford University'),
    partnerName: 'Stanford University',
    image: { url: stanford },
  },
  {
    relationSlug: 'penn',
    imageAltText: _t('University of Pennsylvania'),
    partnerName: 'University of Pennsylvania',
    image: { url: penn },
  },
];
